import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';

export const HEADER_VALUES = [
  $localize`Sort`,
  $localize`Sun`,
  $localize`Mon`,
  $localize`Tue`,
  $localize`Wed`,
  $localize`Thr`,
  $localize`Fri`,
  $localize`Sat`,
];

export const ROW_VALUES = [
  {
    rowName: 'sunrise',
    rowValues: [
      { label: $localize`Sunrise`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'morning',
    rowValues: [
      { label: $localize`Morning`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'day',
    rowValues: [
      { label: $localize`Day`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'twilight',
    rowValues: [
      { label: $localize`Twilight`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'night',
    rowValues: [
      { label: $localize`Night`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'preload',
    rowValues: [
      { label: $localize`Preload`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'local',
    rowValues: [
      { label: $localize`Local`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
  {
    rowName: 'afternoon',
    rowValues: [
      { label: $localize`Afternoon`, formControl: null },
      { label: null, formControl: 'sun' },
      { label: null, formControl: 'mon' },
      { label: null, formControl: 'tue' },
      { label: null, formControl: 'wed' },
      { label: null, formControl: 'thr' },
      { label: null, formControl: 'fri' },
      { label: null, formControl: 'sat' },
    ],
  },
];

export const CVIS_OPTIONS: IOption[] = [
  {
    label: '-5',
    value: -5,
  },
  {
    label: '-4',
    value: -4,
  },
  {
    label: '-3',
    value: -3,
  },
  {
    label: '-2',
    value: -2,
  },
  {
    label: '-1',
    value: -1,
  },
  {
    label: '0',
    value: 0,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
];
